import config from 'config';
import request from 'helpers/superagent';

export const logFatal = (data) => {
  const {access_token} = localStorage;
  return request.post(config.elog.baseUrl + '/fatals')
    .query({
      access_token
    })
    .send({
      data,
    })
    .endAsync();
}



/** WEBPACK FOOTER **
 ** ./src/app/helpers/logServices.js
 **/